import React from 'react'
import CardWThread from '../../blocks/cards/CardWThread'
import { ThreadAPI } from '../../../data/socialize'
import { Route } from '../../../routers/routes'
import { translateIt } from '../../../data/translations'
import Link from 'next/link'
import TextWFileIcon from '../../blocks/typography/TextWIcons/TextWFileIcon'
import Styling from '../../styling'
import CommentCreateForm from '@/library/blocks/threads/CommentCreateForm'


export default function ThreadListItem(props) {
  const {
    item,
    index,
    key_,
  } = props

  const defaultAvatar = `https://i.pravatar.cc/150?u=a04258114e290${item?.username}`
  const connectedToKinds = ThreadAPI.connectedToKinds()
  const countryId = item.country_id
  // TODO: Add comment count
  // TODO: Add Icons or colors per kind


  const getDescription = () => {
    let href = "NOT/SET"
    const linkClassName = "font-bold underline text-body"
    if (item.connected_to_kind === connectedToKinds.PORTFOLIO) {
      href = Route.portfolioDetail({ identifier: item.portfolio_identifier, username: item.target_user_username })
      return <>{translateIt(countryId, 'commentedOn')} <Link href={href}><span className={linkClassName}>{item.target_user_username}s</span></Link> {translateIt(countryId, 'portfolio')}</>
    }


    if (item.connected_to_kind === connectedToKinds.TRANSACTION) {
      const portfolioHref = Route.portfolioDetail({ identifier: item.portfolio_identifier, username: item.target_user_username })
      const instrumentHref = Route.instrumentDetail({ pk: item.transaction_instrument_identifier, ticker: item.transaction_instrument_ticker, slug: item.transaction_instrument_slug })
      if (item.is_default_transaction_thread === 1) {
        return <span className={linkClassName}>
          <Link href={instrumentHref}> {item.transaction_instrument_name}</Link>
        </span>
      } else {
        return (
          <>
            {translateIt(countryId, 'commentedOn')}&nbsp;
            <Link href={portfolioHref} className={linkClassName}>
              {item.target_user_username}s
            </Link>&nbsp;
            {translateIt(countryId, 'transaction')} {translateIt(countryId, 'regarding')}&nbsp;
            <Link href={instrumentHref} className={linkClassName}>{item.transaction_instrument_name}</Link>
          </>
        )
      }
    }
    if (item.connected_to_kind === connectedToKinds.INSTRUMENT) {
      href = Route.instrumentDetail({ pk: item.instrument_identifier, ticker: item.instrument_ticker, slug: item.instrument_slug }) //TODO: Fix this
      return <>{translateIt(countryId, 'commentedOn')} <Link href={href} className={linkClassName}>{item.instrument_name}s</Link></>
    }
    // if (item.connected_to_kind === connectedToKinds.GROUP) {
    //   return <>posted a comment in <span className={linkClassName}>{item.group_name}</span></>
    // }
    if (item.connected_to_kind === connectedToKinds.PUBLICATION) {
      const instrumentHref = Route.instrumentDetail({ pk: item.instrument_identifier, ticker: item.instrument_ticker, slug: item.instrument_slug })
      return <>
        {translateIt(countryId, 'newsUpdateFrom')} <Link className={linkClassName} href={instrumentHref}> {item.instrument_name} </Link>
      </>
    }
    return `NOT HANDLED commented on a ${connectedToKindString} `
  }


  const getCommentList = () => {
    const commentList = item.comments.map(comment => {
      const commentDefaultAvatar = `https://i.pravatar.cc/150?u=a04258114e290${comment?.user_username}`
      return {
        url: comment.user_avatar_url || commentDefaultAvatar,
        name: comment.user_username,
        content: comment.content,
        publishedAt: comment.published_at_str
      }
    })
    return commentList
  }

  const renderPublicationLinkFiles = () => {
    const links = item.publication_files.split(',')
    return <>
      {item.publication_files && (
        <p className="underline mt-4">
          <>
            {links.map((link, index) => {
              const key = `${item.identifier}-${index}-${link}`
              return (
                <a className="block mt-2" key={key} target="_blank" href={link}>
                  <TextWFileIcon text={`${index + 1}. ${translateIt(countryId, 'attachedDocument')} `} />
                </a>
              )
            })}
          </>
        </p>
      )}
    </>
  }

  const renderPublicationContentSummarized = () => {
    return (
      <div>
        {item.publication_file_first_content_summarized && (
          <p className={`mt-2 ${Styling.sizes.sm.default} text-body`}>
            {item.publication_file_first_content_summarized}
          </p>
        )}
      </div>
    )
  }

  const getContent = () => {
    return (
      <>
        {item.content}
        {renderPublicationContentSummarized()}
        {renderPublicationLinkFiles()}
      </>
    )
  }

  const getUserAvatalURL = () => {
    const url = item.user_avatar_url || defaultAvatar
    return url
  }

  return (
    <>
      <CardWThread
        authorNotCenteredInMobile={true}
        authorImageURL={getUserAvatalURL()}
        authorImageAlt={item.username}
        authorImageWidth={128}
        authorImageHeight={128}
        authorUsername={item.username}
        description={getDescription()}
        publishedAt={item.published_at}
        content={getContent()}
        commentList={getCommentList()}
        commentCreateForm={<CommentCreateForm countryId={countryId} thread={item} />}
      />
    </>
  )
}
